import { Box, useMediaQuery } from '@mui/material';
import React from 'react';
import landingPageBottom from '../../assets/landingPageBottom.svg';
import landingPageDefaultImage from '../../assets/landingPageDefaultImage.svg';
export const BackgroundImages = ({ image }) => {
    const downMdScreen = useMediaQuery((theme) => theme.breakpoints.down('md'));
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { component: 'img', sx: {
                position: downMdScreen ? 'absolute' : 'fixed',
                bottom: 0,
                width: '100%',
                pointerEvents: 'none',
                userSelect: 'none',
            }, src: landingPageBottom, alt: '' }),
        React.createElement(Box, { component: 'img', sx: {
                position: downMdScreen ? 'relative' : 'fixed',
                right: 0,
                bottom: 0,
                maxWidth: {
                    xs: '100%',
                    sm: '100%',
                    md: '50%',
                    lg: '50%',
                    xl: '50%',
                },
                maxHeight: {
                    xs: '100%',
                    sm: '100%',
                    md: '100%',
                    lg: '100%',
                    xl: '100%',
                },
                pointerEvents: 'none',
                userSelect: 'none',
            }, src: image !== null && image !== void 0 ? image : landingPageDefaultImage, alt: '' })));
};
